export const PagingFilterTypeEnum = {
  Contains: 1,
  MatchFromStart: 2,
};



// WEBPACK FOOTER //
// ./src/common/Constants/Enumeration/PagingFilterTypeEnum.js